<template>
  <infobulle :descriptionPopup="descriptionPopup">
    <label :for="idInner" v-if="libelleLong"><div v-html="libelleLong" class="mb-1"></div></label>

    <template v-if="modeAffichageCatalogue == 'autocomplete'">
      <v-autocomplete
        :id="idInner"
        :label="label"
        :style="{ width: width + 'px' }"
        :items="list"
        v-bind="$attrs"
        :value="value"
        @change="handleChange"
        :rules="relationRules"
        outlined
        dense
        :multiple="multiple"
        clearable
        :item-text="itemText"
        :item-value="itemValue"
        auto-select-first
        :disabled="updating || disabled"
      >
      </v-autocomplete>
    </template>

    <template v-if="modeAffichageCatalogue == 'select'">
      <v-select
        :id="idInner"
        :label="label"
        :value="value"
        :style="{ width: width + 'px' }"
        :items="list"
        v-bind="$attrs"
        @change="handleChange"
        :rules="relationRules"
        outlined
        dense
        :chips="multiple"
        :multiple="multiple"
        clearable
        :item-text="itemText"
        :item-value="itemValue"
        :disabled="updating || disabled"
      ></v-select>
    </template>

    <template v-if="modeAffichageCatalogue == 'radio'">
      <v-radio-group
        :id="idInner"
        v-bind="$attrs"
        @change="handleChange"
        class="ml-3 mt-0"
        :rules="relationRules"
        :value="value"
        dense
        :multiple="multiple"
        :loading="updating"
        :disabled="updating || disabled"
      >
        <div v-for="item in list" :key="item.id">
          <v-radio :value="item.id" class="my-1">
            <template v-slot:label>
              <span v-html="item.name"></span>
            </template>
          </v-radio>
          <infobulle :descriptionPopup="item.descriptionPopup"></infobulle>
        </div>
      </v-radio-group>
    </template>
  </infobulle>
</template>

<script>
import ChampBase from "@/mixins/ChampBase"
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  data() {
    return {
      updating: false
    }
  },
  props: {
    width: { type: String, default: "270" },
    value: [String, Array, Object],
    code: { type: String, required: true },
    optional: Boolean,
    multiple: { type: Boolean, default: false },
    parent: { type: String },
    live: { type: Object },
    orderBy: { type: String, default: "code" },
    filter: { type: Function },
    list: { type: Array },
    itemText: { type: [String, Function], default: "name" },
    itemValue: { type: String, default: "id" },
    disabled: { type: Boolean, default: false },
    opqIf: { type: Boolean, default: true },
    id: { type: String }
  },
  mixins: [ChampBase],

  computed: {
    relationRules() {
      return [
        (v) => {
          if (this.optional) {
            return true
          }
          if (this.multiple) {
            return v.every((c) => this.list.map((m) => m.id).indexOf(c) > -1)
          } else {
            return this.list.map((m) => m.id).indexOf(v) > -1 || "Ce champ est obligatoire"
          }
        }
      ]
    }
  },

  created() {
    this.list.sort((a, b) => {
      if (a[this.orderBy] < b[this.orderBy]) return -1
      if (a[this.orderBy] > b[this.orderBy]) return 1
      else return 0
    })
  },

  methods: {
    handleChange(event) {
      if (this.live) {
        this.updating = true
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: event
          }).finally(() => {
            this.updating = false
          })
        )
      }
      this.$emit("input", event)
    },
    setValue(value) {
      this.handleChange(value, 8)
    }
  },
  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.handleChange(null)
      }
    }
  }
}
</script>

<style>
</style>